import { ChangeDetectionStrategy, Component, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-training-budget',
  standalone: true,
  imports: [
    CommonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatIconModule,
    FormsModule
  ],
  templateUrl: './training-budget.component.html',
  styleUrls: ['./training-budget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrainingBudgetComponent {
  private isBrowser: boolean;
  private chart: any;

  selectedYear: string = '2025';
  yearOptions = ['2023', '2024', '2025'];

  // ✅ Sample dataset for each year
  private yearData: any = {
    '2023': {
      completed: [80, 95, 100, 110, 120, 30, 100, 105, 95, 115, 120, 130],
      inProgress: [20, 25, 30, 20, 25, 30, 35, 20, 25, 30, 20, 25],
      notSpent: [100, 15, 10, 15, 10, 95, 20, 10, 15, 120, 15, 10]
    },
    '2024': {
      completed: [100, 20, 115, 130, 140, 150, 110, 120, 125, 105, 145, 155],
      inProgress: [30, 35, 25, 40, 30, 35, 25, 30, 35, 40, 25, 30],
      notSpent: [15, 10, 20, 15, 10, 5, 20, 110, 15, 10, 5, 15]
    },
    '2025': {
      completed: [120, 140, 160, 150, 170, 160, 80, 140, 160, 150, 170, 160],
      inProgress: [40, 45, 35, 140, 30, 45, 35, 40, 45, 30, 40, 45],
      notSpent: [120, 15, 10, 15, 20, 25, 10, 115, 20, 15, 10, 15]
    }
  };

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.renderChart(this.selectedYear);
    }
  }

  async renderChart(year: string): Promise<void> {
    if (!this.isBrowser) return;

    try {
      const ApexCharts = (await import('apexcharts')).default;
      if (this.chart) {
        this.chart.destroy();
      }

      const dataset = this.yearData[year];

      const options = {
        series: [
          { name: 'Completed', data: dataset.completed },
          { name: 'In Progress', data: dataset.inProgress },
          { name: 'Not Spent', data: dataset.notSpent }
        ],
        chart: {
          type: 'bar',
          height: 345,
          stacked: true,
          toolbar: { show: true },
          zoom: { enabled: false }
        },
        plotOptions: {
          bar: { horizontal: false, borderRadius: 6, columnWidth: '80%' }
        },
        colors: ['#07146fff', '#f1bd00ff', '#157e00ff'],
        dataLabels: {
          enabled: false
        },
        // xaxis: {
        //   categories: [
        //     'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        //     'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        //   ],
        //   title: { text: 'Months' },
        //   labels: {
        //     style: { colors: '#64748B', fontSize: '12px' }
        //   },
        //   axisBorder: { show: false },
        //   axisTicks: { show: false }
        // },
        // yaxis: {
        //   title: { text: 'Budget (in Lakhs)' },
        //   labels: {
        //     style: { colors: '#64748B', fontSize: '12px' }
        //   }
        // },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          fontSize: '13px',
          markers: { size: 8 },
          labels: { colors: '#475569' }
        },
        grid: {
          show: true,
          borderColor: '#ECEEF2',
          strokeDashArray: 3
        },
        tooltip: {
          y: { formatter: (val: number) => `${val} L` }
        }
      };

      this.chart = new ApexCharts(document.querySelector('#training_budget_chart'), options);
      this.chart.render();
    } catch (error) {
      console.error('Error rendering chart:', error);
    }
  }

  onYearChange(): void {
    if (this.isBrowser) {
      this.renderChart(this.selectedYear);
    }
  }
}
